<template>
  <div class="subEvent">
    <Breadcrumb />
    <el-main>
      <EventDesc />
      <el-row class="nofull event_content">
        <EventMenu :menuActiveId="menuActiveId" />
        <el-main>
          <!--<el-table
                            :data="tableData"
                            border
                            style="width: 100%">
                        <el-table-column
                                fixed
                                prop="seName"
                                label="分会议名称"
                                width="150">
                        </el-table-column>
                        <el-table-column
                                prop="seDesc"
                                label="分会议简介"
                                width="260">
                        </el-table-column>
                        <el-table-column
                                prop="seAddress"
                                label="地址"
                                width="160">
                        </el-table-column>
                        <el-table-column
                                prop="seManager"
                                label="负责人"
                                width="80">
                        </el-table-column>
                        <el-table-column
                                prop="seManagerTel"
                                label="负责人电话"
                                width="120">
                        </el-table-column>
                        <el-table-column
                                prop="seStartTime"
                                label="开始时间"
                                width="100">
                        </el-table-column>
                        <el-table-column
                                prop="seEndTime"
                                label="结束时间"
                                width="100">
                        </el-table-column>
                        <el-table-column
                                fixed="right"
                                label="操作"
                                width="60">
                            <template slot-scope="scope">
                                <el-button @click="handleClick(scope.row)" type="text" size="small">详情</el-button>
                                <el-button type="text" size="small">日程</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    -->
          <el-table
            :row-key="getRowKeys"
            @row-click="clickRowHandle"
            :expand-row-keys="expands"
            @expand-change="expandSelect"
            :data="tableData"
            style="width: 100%"
            class="expandTable"
          >
            <el-table-column type="expand">
              <template slot-scope="props">
                <el-main>
                  <el-row :gutter="10">
                    <el-col :span="12"
                      ><span>分会议名称：</span>{{ props.row.name }}</el-col
                    >
                    <el-col :span="12"
                      ><span>分会议地址：</span>{{ props.row.location }}</el-col
                    >
                  </el-row>

                  <el-row :gutter="10">
                    <el-col :span="12">
                      <el-row :gutter="10">
                        <el-col :span="24"
                          ><span>联系人：</span>{{ props.row.chairman }}</el-col
                        >
                        <el-col :span="24"
                          ><span>联系人电话：</span
                          >{{ props.row.contact }}</el-col
                        >
                      </el-row>
                    </el-col>
                    <el-col :span="12">
                      <el-row :gutter="10">
                        <el-col :span="24"
                          ><span>开始时间：</span
                          >{{
                            changetoLocaleString(
                              props.row.setting_json.start_time,
                            )
                          }}</el-col
                        >
                        <el-col :span="24"
                          ><span>结束时间：</span
                          >{{
                            changetoLocaleString(
                              props.row.setting_json.end_time,
                            )
                          }}</el-col
                        >
                      </el-row>
                    </el-col>
                  </el-row>
                  <el-row style="margin-top: 20px">
                    <span>分会议简介：</span>
                    <p v-html="props.row.setting_json.summary"></p>
                  </el-row>
                  <el-row>
                    <span>分会议详情：</span>
                    <div v-html="props.row.setting_json.description"></div>
                  </el-row>
                  <el-row>
                    <span>分会议日程：</span>
                    <div v-html="props.row.setting_json.schedule"></div>
                  </el-row>
                </el-main>
              </template>
            </el-table-column>
            <el-table-column label="分会议名称" prop="name"> </el-table-column>
            <el-table-column label="开始时间">
              <template slot-scope="props">
                {{ changetoLocaleString(props.row.setting_json.start_time) }}
              </template>
            </el-table-column>
            <el-table-column label="结束时间">
              <template slot-scope="props">
                {{ changetoLocaleString(props.row.setting_json.end_time) }}
              </template>
            </el-table-column>
          </el-table>
        </el-main>
      </el-row>
    </el-main>
  </div>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb.vue';
import EventDesc from '@/components/EventDesc.vue';
import EventMenu from '@/components/EventMenu.vue';
import { getSubForum } from '@/apis/subForumInfo.js';
export default {
  name: 'SubEvent',
  components: {
    Breadcrumb,
    EventDesc,
    EventMenu,
  },
  mounted() {
    this.$emit('activeIndex', '2');
    this.$emit('pageClass', 'event');
    let forum_id = this.$route.query.eventId;
    getSubForum(forum_id)
      .then((res) => {
        console.log('XXXXXXXXXXXXXXXXXXX');
        if (res.status === 200) {
          if (res.data.success === true) {
            console.log(res.data);

            for (let i = 0; i < res.data.data.items.length; i++) {
              for (let j = i + 1; j < res.data.data.items.length; j++) {
                let x1 = res.data.data.items[i];
                let x2 = res.data.data.items[j];

                if (x2.sort_order < x1.sort_order) {
                  let temp = res.data.data.items[i];
                  res.data.data.items[i] = res.data.data.items[j];
                  res.data.data.items[j] = temp;
                }
              }
            }

            this.tableData = res.data.data.items;
            this.tableData.setting_json = res.data.data.items.setting_json;
          } else {
            this.$message({
              showClose: true,
              message: res.data.message,
              type: 'success',
            });
          }
        } else {
          this.$message.error('未请求成功');
        }
      })
      .catch((error) => {
        console.log(error);
      });
  },
  data() {
    return {
      expands: [],
      getRowKeys(row) {
        return row.sub_forum_id;
      },

      menuActiveId: '2',
      tableData: [],
    };
  },
  methods: {
    dateFormat(fmt, date) {
      let ret;
      const opt = {
        'Y+': date.getFullYear().toString(), // 年
        'm+': (date.getMonth() + 1).toString(), // 月
        'd+': date.getDate().toString(), // 日
        'H+': date.getHours().toString(), // 时
        'M+': date.getMinutes().toString(), // 分
        'S+': date.getSeconds().toString(), // 秒
        // 有其他格式化字符需求可以继续添加，必须转化成字符串
      };
      for (let k in opt) {
        ret = new RegExp('(' + k + ')').exec(fmt);
        if (ret) {
          fmt = fmt.replace(
            ret[1],
            ret[1].length == 1 ? opt[k] : opt[k].padStart(ret[1].length, '0'),
          );
        }
      }
      return fmt;
    },
    changetoLocaleString(str) {
      if (str) {
        // let localeTime = new Date(str);
        // return this.common.dateFormat("YYYY/mm/dd", localeTime)
        return this.$moment(str).format('YYYY-MM-DD');
      } else {
        return str;
      }
    },
    // 折叠面板每次只能展开一行
    clickRowHandle(row, expandedRows) {
      this.expandSelect(row, expandedRows);
    },
    expandSelect(row, expandedRows) {
      // console.log('expandedRows', expandedRows)
      // console.log('row', row)

      let that = this;
      if (expandedRows.length !== 0) {
        that.expands = [];
        if (row) {
          that.expands.push(row.sub_forum_id); // 每次push进去的是每行的ID
        }
      } else {
        that.expands = []; // 默认不展开
      }
      // console.log('that.expands', that.expands)
    },
  },
  watch: {
    '$store.state.toGetCurrentEvent.currentEvent'(v) {
      document.title = '分会议日程 - '+v.name;
    },
  },
};
</script>

<style scoped>
.demo-table-expand {
  font-size: 0;
}
.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}
.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
</style>
